module.exports = __webpack_public_path__ + "static/pantry-oranges-1aa1af5e0655f1a76040bc0217092fcc.jpg";